<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <componentheader :title="title" />

        <div class="row">
          <div class="col-xl-3 col-md-4">
            <settingsidebar />
          </div>

          <div class="col-xl-9 col-md-8">
            <div class="card">
              <div class="card-header">
                <h5 class="card-title">Tax</h5>
              </div>
              <div class="card-body">
                <!-- Form -->
                <Form @submit.prevent="updateSettings">
                  <div class="row form-group mb-0">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                    ></label>
                    <div class="col-sm-9">
                      <label class="custom_check me-3">
                        <input
                          type="checkbox"
                          true-value="1"
                          false-value="0"
                          v-model="form.auto_enable_tax"
                          name="tax_enabled"
                        />
                        <span class="checkmark"></span> Auto enable tax
                      </label>
                    </div>
                  </div>

                  <div class="row form-group">
                    <label
                      for="currencyLabel"
                      class="col-sm-3 col-form-label input-label"
                      >Tax Percentage</label
                    >
                    <div class="col-sm-9">
                      <input
                        type="number"
                        step="0.01"
                        v-model="form.tax_percentage"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="text-end">
                    <button
                      :disabled="isLoading"
                      type="submit"
                      class="btn btn-primary add-tax-save-btn"
                    >
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="!isLoading">Save Changes</span>
                      <span v-if="isLoading">Saving...</span>
                    </button>
                  </div>
                </Form>
                <!-- /Form -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();
const title = " Settings";
const isLoading = ref(false);

const form = ref({
  auto_enable_tax: "0",
  tax_percentage: "",
});

const settings = computed(() => {
  return store.getters["settings/settings"];
});

const getSettings = () => {
  store.dispatch("settings/getSettings").then(() => {
    form.value = {
      auto_enable_tax: settings.value.auto_enable_tax,
      tax_percentage: settings.value.tax_percentage,
    };
  });
};

const updateSettings = () => {
  isLoading.value = true;
  store
    .dispatch("settings/updateTaxSettings", form.value)
    .then(() => {
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
    });
};

onMounted(() => {
  getSettings();
});
</script>
